import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'user-timeline',
  template: require('./user.timeline.component.html')
})
export class UserTimelineComponent {
  @Input() user: any;
  @Input() activity: any;
  @Input() project: any;
  @Input() activityPage: number = 1;
  @Input() activityPageSize: number = 20;
  @Input() hasNextPage: boolean = false;

  @Output() onpage: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  changePage(page: any): void {
    this.onpage.emit(page);
  }
}
